import { useQuery } from '@tanstack/react-query';
import { gqlClient } from './gqlClient';

export const fetchCompanies = async () => {
  const { getCompanies } = await gqlClient.query({
    getCompanies: {
      __args: { args: { payingCompaniesOnly: false } },
      id: true,
      name: true,
      email: true,
      isArchived: true,
      isTestCompany: true,
      dataRestrictionTime: true,
    },
  });

  return getCompanies.map((company) => ({ ...company, name: company.name ?? '' }));
};

export const useCompanies = () => {
  const { data: companies, isLoading } = useQuery(['companies'], async () => await fetchCompanies(), {
    refetchInterval: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return { companies, isLoading };
};
